import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { configureStore } from "@reduxjs/toolkit";
import "antd/dist/antd.variable.min.css";
import "./index.css";
import { reCAPTCHA, app } from "./config/config";
import rootReducers from "./store/root.reducer";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./lang/i18n";

const moment = require('moment');

moment.updateLocale('en', {
  week: {
    dow: 1, // Monday is the first day of the week.
  }
});

if (window.location.hostname === "localhost") {
  window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(reCAPTCHA),
  isTokenAutoRefreshEnabled: true,
});

const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

if (process.env.NODE_ENV !== "development") {
  console.log = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
